HomeMobile = {
	
	init: ->
		console.log "HomeMobile init"

		@introManager()

	introManager : ->
		$('.home-mobile .cta_enter').on "click", (ev) ->
			introElt = $('.home-mobile--intro')
			searchElt = $('.home-mobile--search')
			tlShowSearch = new TimelineLite
			tlShowSearch.addLabel('start')
				.to introElt.find('.cta_enter'), 0.4, {scale:1.1, ease:Quint.easeOut}, 'start'
				.to introElt.find('.cta_enter'), 0.4, {scale:0.8, autoAlpha:0, ease:Quint.easeOut}
				.to introElt, 0.8, {x:'-100%', ease:Expo.easeInOut}, 'start+=0.4'

	destroy: ->
		console.log "HomeMobile destroy"
}